import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { verifyStripeSession } from "@/lib/api";

export default function StripeSuccessPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // "verifying" | "success" | "error"
  const [plan, setPlan] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      setStatus("error");
      setErrorMsg("No session ID found. Your payment may still have gone through — check your email for a receipt.");
      return;
    }

    verifyStripeSession(sessionId)
      .then((data) => {
        if (data.status === "active") {
          setPlan(data.plan);
          setStatus("success");
          // After 3 seconds, go to connections page so they can connect HubSpot
          setTimeout(() => navigate("/connections?subscribed=1", { replace: true }), 3000);
        } else {
          setStatus("error");
          setErrorMsg(`Payment status: ${data.status}. If you were charged, please contact support.`);
        }
      })
      .catch((err) => {
        setStatus("error");
        setErrorMsg(err.response?.data?.detail || "Unable to verify payment. Please contact support if you were charged.");
      });
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#323c44] px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#323c44] p-10 text-center">

        {status === "verifying" && (
          <>
            <Loader2 className="mx-auto mb-4 h-12 w-12 animate-spin text-[#119996]" />
            <h2 className="text-xl font-bold text-white">Confirming your subscription…</h2>
            <p className="mt-2 text-sm text-slate-400">Just a moment while we activate your account.</p>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircle2 className="mx-auto mb-4 h-12 w-12 text-emerald-400" />
            <h2 className="text-xl font-bold text-white">You're all set!</h2>
            <p className="mt-2 text-sm text-slate-400">
              Your <span className="font-semibold capitalize text-white">{plan}</span> plan is active.
              Taking you to your reports now…
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <XCircle className="mx-auto mb-4 h-12 w-12 text-red-400" />
            <h2 className="text-xl font-bold text-white">Something went wrong</h2>
            <p className="mt-2 text-sm text-slate-400">{errorMsg}</p>
            <button
              type="button"
              onClick={() => navigate("/connections")}
              className="mt-6 rounded-lg bg-[#50e3c2] px-6 py-2.5 text-sm font-semibold text-[#323c44] hover:bg-[#57c1a9]"
            >
              Go to Connections
            </button>
          </>
        )}

      </div>
    </div>
  );
}
